import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Until each section is built, all menu routes render the Coming Soon page
const comingSoon = () => import('../views/coming-soon/coming-soon.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: comingSoon
  },
  {
    path: '/about',
    name: 'about',
    component: comingSoon
  },
  {
    path: '/driver-training',
    name: 'driver-training',
    component: comingSoon
  },
  {
    path: '/wrl-2026',
    name: 'wrl-2026',
    component: comingSoon
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: comingSoon
  },
  {
    path: '/contact',
    name: 'contact',
    component: comingSoon
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
